import React, {useState, useEffect, useRef} from 'react'

import {CheckCircleIcon, XCircleIcon} from '@heroicons/react/solid'

import sdk from "scoutli-sdk";

import {useNavigate} from "react-router-dom";

const tabs = [
    {id: 0, name: 'My Reports'},
    {id: 1, name: 'Ongoing Reports'}
]

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function Reports() {
    const Paddle = window.Paddle;

    const [type, setType] = useState(0)
    const [user, setUser] = useState(null)

    const [reportType, setReportType] = useState(0)

    const [reports, setReports] = useState(null)

    const [loading, setLoading] = useState(false)

    const [alert, setAlert] = useState(false)

    const [alertOpen, setAlertOpen] = useState(false)

    const [isCreating, setCreating] = useState(false)

    const [canDownload, setCanDownload] = useState(true)

    const [canCreate, setCanCreate] = useState(true)

    const navigate = useNavigate()

    const game = useRef(0)
    const report = useRef(0)
    const team = useRef("")
    const name = useRef("")
    const nickname = useRef("")
    const extra = useRef("")
    const tournament = useRef("")

    const accessToken = localStorage.getItem("accessToken")

    useEffect(() => {
        Paddle.Setup({
            vendor: 137571,
            eventCallback: function (eventData) {
                if (eventData.event === "Checkout.Complete"){
                    setCanCreate(true)

                    window.location.reload()
                }
                else if (eventData.event === "Checkout.Close") {
                    setCanCreate(true)
                }
            }
        });

        sdk.user(accessToken).get.userData().then(data => setUser(data)).catch(() => {
            return navigate("/")
        })

        sdk.user(accessToken).reports.get().then(data => {
            setReports(data)
        }).catch(() => {
            return navigate("/")
        }).finally(() => {
            setLoading(false)
        });
    }, [])

    if (loading) return (
        <>
        </>
    );

    const reportTypes = [
        "Player Scouting Report",
        "Tournament Performance Report",
        "Player Performance Report"
    ];

    const games = [
        "VALORANT",
        "League of Legends",
        "Wild Rift"
    ];

    const reportToType = (report) => {
        let type = reportTypes.findIndex(_reportType => {
            return _reportType === report;
        });

        return type ?? 0;
    }

    const typeToReport = (type) => {
        let report = reportTypes[type];

        return report ?? "Unknown";
    }

    const gameToType = (game) => {
        let type = games.findIndex(_game => {
            return _game === game;
        });

        return type ?? 0;
    }

    const typeToGame = (type) => {
        let game = games[type];

        return game ?? "Unknown";
    }

    return (
        <div className="flex flex-col gap-y-6 h-full">
            <div
                className={`fixed bottom-5 z-10 left-5 sm:left-auto right-5 transition-all ${alertOpen !== false ? "visible opacity-100" : "invisible opacity-0"}`}>
                <div
                    className={`flex items-center rounded-md ${alert.type ? "bg-green-50" : "bg-red-50"} p-3 max-w-max`}>
                    {alert.type && (
                        <CheckCircleIcon className="h-5 w-5 text-green-400" aria-hidden="true"/>
                    )}

                    {!alert.type && (
                        <XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true"/>
                    )}

                    <div className="ml-3">
                        {alert.type && (
                            <h3 className="text-sm font-medium text-green-800 mb-0">{alert.text}</h3>
                        )}

                        {!alert.type && (
                            <h3 className="text-sm font-medium text-red-800 mb-0">{alert.text}</h3>
                        )}
                    </div>
                </div>
            </div>

            <div className="sm:hidden">
                <label htmlFor="tabs" className="sr-only">
                    Select a tab
                </label>

                <select
                    id="tabs"
                    name="tabs"
                    className="w-full pl-3 pr-10 py-2 text-base border-gray-300 transition-colors focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                    defaultValue={tabs.find((tab) => tab.id === type).name}
                    onChange={e => {
                        setType(tabs.find(tab => tab.name === e.target.value).id ?? 0)

                        setCreating(false)
                    }}
                >
                    {tabs.map((tab) => (
                        <option key={tab.name}>{tab.name}</option>
                    ))}
                </select>

                {type === 0 && !isCreating && (
                    <a onClick={() => {
                        setCreating(true)
                    }}
                       className="text-sm w-full flex items-center justify-center font-medium cursor-pointer text-primary mt-4 transition-colors hover:text-indigo-700">
                        Create a Request
                    </a>
                )}
            </div>

            <div className="hidden sm:block">
                <div className="border-b border-gray-200">
                    <nav className="-mb-px flex justify-between" aria-label="Tabs">
                        <div className="flex gap-x-8 items-center justify-center">
                            {tabs.map((tab) => (
                                <a
                                    key={tab.name}
                                    className={classNames(
                                        tab.id === type
                                            ? 'border-indigo-500 text-indigo-600'
                                            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                                        'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm cursor-pointer'
                                    )}
                                    onClick={() => {
                                        setType(tab.id)

                                        setCreating(false)
                                    }}
                                    aria-current={tab.id === type ? 'page' : undefined}
                                >
                                    {tab.name}
                                </a>
                            ))}
                        </div>


                        {!isCreating && (
                            <a onClick={() => {
                                setCreating(true)
                            }}
                               className="text-sm font-medium cursor-pointer text-primary mt-4 transition-colors hover:text-indigo-700">
                                Request Report
                            </a>
                        )}
                    </nav>
                </div>
            </div>

            {type === 0 && !isCreating && (
                <div className="flex flex-col">
                    <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                            <div className="shadow-sm overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead className="bg-gray-50">
                                    <tr>
                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Event/Player Name
                                        </th>

                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Requested At
                                        </th>

                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Submitted At
                                        </th>

                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Report Type
                                        </th>

                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Team
                                        </th>

                                        <th scope="col" className="relative px-6 py-3">
                                            <span className="sr-only">Download</span>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                    {reports !== null && reports.filter(report => {
                                        return report.uploadedAt !== null;
                                    }).map((report, index) => (
                                        <tr key={index}>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div
                                                    className="text-sm text-gray-900 font-medium">{report.information.playerNickname ?? report.information.tournamentName ?? ""}</div>
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div
                                                    className="text-sm text-gray-500">{(new Date(report.createdAt).toLocaleString())}</div>
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div
                                                    className="text-sm text-gray-500">{(new Date(report.uploadedAt).toLocaleString())}</div>
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{typeToReport(report.reportType)}</td>

                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{report.information.playerTeam}</td>

                                            <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                                <button disabled={!canDownload} onClick={() => {
                                                    setAlert({
                                                        type: true,
                                                        text: "Your download will begin in a few seconds..."
                                                    })

                                                    setAlertOpen(true)

                                                    setCanDownload(false)

                                                    sdk.user(accessToken).reports.download(report._id).then(response => {
                                                        let a = document.createElement("a")

                                                        let binary = "";
                                                        let bytes = new Uint8Array(response.buffer);
                                                        let len = bytes.byteLength;

                                                        for (let i = 0; i < len; i++) {
                                                            binary += String.fromCharCode(bytes[i]);
                                                        }

                                                        a.href = `data:${response.extension};base64,${btoa(binary)}`
                                                        a.download = "Scoutli-Report"

                                                        a.click()

                                                        setAlert({
                                                            type: true,
                                                            text: "Your download has been finished!"
                                                        })

                                                        setAlertOpen(true)

                                                        setCanDownload(true)
                                                    }).catch(response => {
                                                        setAlert({
                                                            type: false,
                                                            text: "Your download won't begin!"
                                                        })

                                                        setAlertOpen(true)

                                                        setCanDownload(true)
                                                    }).finally(() => {
                                                        setTimeout(() => {
                                                            setAlertOpen(false)

                                                            setCanDownload(true)
                                                        }, 3000)
                                                    });
                                                }}
                                                        className={canDownload ? "text-indigo-600 transition-colors hover:text-indigo-800" : "transition-colors text-gray-300"}>
                                                    Download
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {type === 1 && !isCreating && (
                <div className="flex flex-col">
                    <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                            <div className="shadow-sm overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead className="bg-gray-50">
                                    <tr>
                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Event/Player Name
                                        </th>

                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Requested At
                                        </th>

                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Report Type
                                        </th>

                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Team
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                    {reports !== null && reports.filter(report => {
                                        return report.uploadedAt === null;
                                    }).map((report, index) => (
                                        <tr key={index}>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div
                                                    className="text-sm text-gray-900 font-medium">{report.information.playerNickname ?? report.information.tournamentName ?? ""}</div>
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div
                                                    className="text-sm text-gray-500">{(new Date(report.createdAt).toLocaleString())}</div>
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{typeToReport(report.reportType)}</td>

                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{report.information.playerTeam}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {isCreating && (
                <div className="pt-0 sm:pt-8">
                    <div className="md:grid md:grid-cols-3 md:gap-6">
                        <div className="md:col-span-1">
                            <div className="px-4 sm:px-0">
                                <h3 className="text-lg font-medium leading-6 text-gray-900">Create a Report Request</h3>
                                <p className="mt-1 text-sm text-gray-600">
                                    Choose the report type and the other details.
                                </p>
                            </div>
                        </div>
                        <div className="md:col-span-2 mt-8 sm:mt-0">
                            <form action="#" method="POST" onSubmit={event => {
                                event.preventDefault()

                                setCanCreate(false)

                                Paddle.Checkout.open({
                                    product: 759875,
                                    allowQuantity: false,
                                    disableLogout: true,
                                    email: user.email,
                                    passthrough: JSON.stringify({
                                        user: user.id,
                                        gameId: gameToType(game.current.value),
                                        reportType: reportType,
                                        information: reportType === 0 ? {
                                            playerName: name.current.value,
                                            playerNickname: nickname.current.value,
                                            playerTeam: team.current.value
                                        } : {
                                            teamName: team.current.value,
                                            tournamentName: tournament.current.value
                                        },
                                        extra: extra.current.value
                                    })
                                });
                            }}>
                                <div className="sm:rounded-md sm:overflow-hidden">
                                    <div className="px-4 bg-white space-y-6">
                                        <div className="grid grid-cols-3 gap-6">
                                            <div className="col-span-3 sm:col-span-2">
                                                <label htmlFor="game"
                                                       className="block text-sm font-medium text-gray-700">
                                                    Game
                                                </label>

                                                <select
                                                    name="game"
                                                    id="game"
                                                    ref={game}
                                                    className="mt-2 focus:ring-indigo-500 transition-colors focus:border-indigo-500 pr-10 py-2 pl-3 flex-1 block w-full rounded-md sm:text-sm border-gray-300"
                                                    defaultValue="VALORANT"
                                                >
                                                    <option>VALORANT</option>
                                                    <option>League of Legends</option>
                                                    <option>Wild Rift</option>
                                                </select>
                                            </div>

                                            <div className="col-span-3 sm:col-span-2">
                                                <label htmlFor="game"
                                                       className="block text-sm font-medium text-gray-700">
                                                    Report Type
                                                </label>

                                                <select
                                                    name="report"
                                                    id="report"
                                                    ref={report}
                                                    className="mt-2 focus:ring-indigo-500 transition-colors focus:border-indigo-500 pr-10 py-2 pl-3 flex-1 block w-full rounded-md sm:text-sm border-gray-300"
                                                    defaultValue="Player Scouting Report"
                                                    onChange={event => {
                                                        setReportType(reportToType(event.target.value))
                                                    }}
                                                >
                                                    <option>Player Scouting Report</option>
                                                    <option>Tournament Performance Report</option>
                                                    <option>Player Performance Report</option>
                                                </select>
                                            </div>

                                            {reportType === 0 && (
                                                <>
                                                    <div className="col-span-3 sm:col-span-2">
                                                        <label htmlFor="team"
                                                               className="block text-sm font-medium text-gray-700">
                                                            Player’s Team*
                                                        </label>

                                                        <input
                                                            required
                                                            type="text"
                                                            name="team"
                                                            id="team"
                                                            ref={team}
                                                            className="mt-2 focus:ring-indigo-500 transition-colors focus:border-indigo-500 flex-1 block w-full rounded-md sm:text-sm border-gray-300"
                                                            placeholder="SuperMassive Blaze"
                                                        />
                                                    </div>

                                                    <div className="col-span-3 sm:col-span-2">
                                                        <label htmlFor="name"
                                                               className="block text-sm font-medium text-gray-700">
                                                            Player’s Name*
                                                        </label>

                                                        <input
                                                            required
                                                            type="text"
                                                            name="name"
                                                            id="name"
                                                            ref={name}
                                                            className="mt-2 focus:ring-indigo-500 transition-colors focus:border-indigo-500 flex-1 block w-full rounded-md sm:text-sm border-gray-300"
                                                            placeholder="Izzettin Karabacak"
                                                        />
                                                    </div>

                                                    <div className="col-span-3 sm:col-span-2">
                                                        <label htmlFor="nickname"
                                                               className="block text-sm font-medium text-gray-700">
                                                            Player’s Nickname*
                                                        </label>

                                                        <input
                                                            required
                                                            type="text"
                                                            name="nickname"
                                                            id="nickname"
                                                            ref={nickname}
                                                            className="mt-2 focus:ring-indigo-500 transition-colors focus:border-indigo-500 flex-1 block w-full rounded-md sm:text-sm border-gray-300"
                                                            placeholder="Izze"
                                                        />
                                                    </div>

                                                    <div className="col-span-3 sm:col-span-2">
                                                        <label htmlFor="extra"
                                                               className="block text-sm font-medium text-gray-700">
                                                            Extra Information
                                                        </label>

                                                        <textarea
                                                            id="extra"
                                                            name="extra"
                                                            rows={3}
                                                            ref={extra}
                                                            className="mt-2 p-2 resize-none h-24 transition-colors focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md"
                                                        />

                                                        <p className="mt-2 text-sm text-gray-500">
                                                            Do you want to tell us anything else?
                                                        </p>
                                                    </div>
                                                </>
                                            )}

                                            {reportType === 1 && (
                                                <>
                                                    <div className="col-span-3 sm:col-span-2">
                                                        <label htmlFor="team"
                                                               className="block text-sm font-medium text-gray-700">
                                                            Team Name*
                                                        </label>

                                                        <input
                                                            required
                                                            type="text"
                                                            name="team"
                                                            id="team"
                                                            ref={team}
                                                            className="mt-2 focus:ring-indigo-500 transition-colors focus:border-indigo-500 flex-1 block w-full rounded-md sm:text-sm border-gray-300"
                                                            placeholder="SuperMassive Blaze"
                                                        />
                                                    </div>

                                                    <div className="col-span-3 sm:col-span-2">
                                                        <label htmlFor="tournament"
                                                               className="block text-sm font-medium text-gray-700">
                                                            Tournament Name*
                                                        </label>

                                                        <input
                                                            required
                                                            type="text"
                                                            name="tournament"
                                                            id="tournament"
                                                            ref={tournament}
                                                            className="mt-2 focus:ring-indigo-500 transition-colors focus:border-indigo-500 flex-1 block w-full rounded-md sm:text-sm border-gray-300"
                                                            placeholder="PCS5: MEA Playoffs"
                                                        />
                                                    </div>

                                                    <div className="col-span-3 sm:col-span-2">
                                                        <label htmlFor="team-description"
                                                               className="block text-sm font-medium text-gray-700">
                                                            Extra Information
                                                        </label>

                                                        <textarea
                                                            id="team-description"
                                                            name="team-description"
                                                            rows={3}
                                                            ref={extra}
                                                            className="mt-2 p-2 resize-none h-24 transition-colors focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md"
                                                        />

                                                        <p className="mt-2 text-sm text-gray-500">
                                                            Do you want to tell us anything else?
                                                        </p>
                                                    </div>
                                                </>
                                            )}

                                            {reportType === 2 && (
                                                <>
                                                    <div className="col-span-3 sm:col-span-2">
                                                        <label htmlFor="team"
                                                               className="block text-sm font-medium text-gray-700">
                                                            Player’s Team*
                                                        </label>

                                                        <input
                                                            required
                                                            type="text"
                                                            name="team"
                                                            id="team"
                                                            ref={team}
                                                            className="mt-2 focus:ring-indigo-500 transition-colors focus:border-indigo-500 flex-1 block w-full rounded-md sm:text-sm border-gray-300"
                                                            placeholder="SuperMassive Blaze"
                                                        />
                                                    </div>

                                                    <div className="col-span-3 sm:col-span-2">
                                                        <label htmlFor="name"
                                                               className="block text-sm font-medium text-gray-700">
                                                            Player’s Name*
                                                        </label>

                                                        <input
                                                            required
                                                            type="text"
                                                            name="name"
                                                            id="name"
                                                            ref={name}
                                                            className="mt-2 focus:ring-indigo-500 transition-colors focus:border-indigo-500 flex-1 block w-full rounded-md sm:text-sm border-gray-300"
                                                            placeholder="Izzettin Karabacak"
                                                        />
                                                    </div>

                                                    <div className="col-span-3 sm:col-span-2">
                                                        <label htmlFor="nickname"
                                                               className="block text-sm font-medium text-gray-700">
                                                            Player’s Nickname*
                                                        </label>

                                                        <input
                                                            required
                                                            type="text"
                                                            name="nickname"
                                                            id="nickname"
                                                            ref={nickname}
                                                            className="mt-2 focus:ring-indigo-500 transition-colors focus:border-indigo-500 flex-1 block w-full rounded-md sm:text-sm border-gray-300"
                                                            placeholder="Izze"
                                                        />
                                                    </div>

                                                    <div className="col-span-3 sm:col-span-2">
                                                        <label htmlFor="extra"
                                                               className="block text-sm font-medium text-gray-700">
                                                            Extra Information
                                                        </label>

                                                        <textarea
                                                            id="extra"
                                                            name="extra"
                                                            rows={3}
                                                            ref={extra}
                                                            className="mt-2 p-2 resize-none h-24 transition-colors focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md"
                                                        />

                                                        <p className="mt-2 text-sm text-gray-500">
                                                            Do you want to tell us anything else? VLR.GG, PUBG.OP.GG
                                                            links might speed up the process.
                                                        </p>
                                                    </div>
                                                </>
                                            )}
                                        </div>

                                        <div className="col-span-3 sm:col-span-2 sm:pb-0">
                                            <div className="flex justify-end">
                                                <button
                                                    onClick={() => {
                                                        setCreating(false)
                                                    }}
                                                    type="button"
                                                    className="py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50"
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    disabled={!canCreate}
                                                    type="submit"
                                                    className={`ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md transition-colors ${canCreate ? "bg-primary text-white hover:bg-indigo-600" : "bg-gray-50 text-gray-300"}`}
                                                >
                                                    Create
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {type === 1 && (
                <>
                </>
            )}
        </div>
    )
}
